export const POPUP_LIMIT = 7;
